import { render, staticRenderFns } from "./FutureRuleDia.vue?vue&type=template&id=e620f000&scoped=true"
import script from "./FutureRuleDia.vue?vue&type=script&lang=js"
export * from "./FutureRuleDia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e620f000",
  null
  
)

export default component.exports